// extracted by mini-css-extract-plugin
export default {"modal":"CopyTemplateModal-module__modal__k7Ei+","content":"CopyTemplateModal-module__content__EjMJ4","alert":"CopyTemplateModal-module__alert__a0VVG"};